// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'

import { MessageTemplateEditor } from './common/MessageTemplateEditor/MessageTemplateEditor'

export const Editors = React.forwardRef(
  (
    {
      error,
      id,
      name,
      placeholder,
      value,
      variables,
      onBlur,
      onChange,
      isDisabled,
      isRequired,
    },
    ref,
  ) => (
    <MessageTemplateEditor
      {...{
        error,
        id,
        name,
        placeholder,
        ref,
        value,
        variables,
        onBlur,
        onChange,
        isDisabled,
        isRequired,
      }}
    />
  ),
)

export const ControlledEditors = ({
  control,
  error,
  id,
  name,
  placeholder,
  variables,
  isDisabled,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Editors
        {...{
          error,
          id,
          name,
          placeholder,
          ref,
          value,
          variables,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
